package com.bikompanion.domain

/**
 * The shape of a bike parking spot, as OSM's `bicycle_parking` tag has it.
 *
 * OSM has many more values than this (`bollard`, `crossbar`, `two-tier`, `ground_slots`, …) — too
 * many to give each its own icon without the map turning into a legend. Every value collapses
 * into whichever of these it most resembles, with [Other] as the catch-all for the long tail and
 * anything untagged.
 */
enum class ParkingType {
    Other,
    Stands,
    Shed,
    Lockers,
    Building,
}
